import type { UpdateSizingConfigDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import { useQueryClient } from "@tanstack/react-query";

export default function useUpdateSizingConfig(shopId: string) {
	const queryClient = useQueryClient();

	return useApiMutation("patch", "/shops/{shopId}/sizing/config", {
		invalidate: () => {
			queryClient.invalidateQueries({
				queryKey: ["get", "/shops/{shopId}/sizing/config"],
			});
		},
		mapVariables: (body: UpdateSizingConfigDto) => ({
			params: { path: { shopId } },
			body,
		}),
	});
}
